export const REQUEST = 'Admin/Points/REQUEST';
export const SUCCESS = 'Admin/Points/SUCCESS';
export const ERROR = 'Admin/Points/ERROR';

export const SET = 'Admin/Points/SET';